import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';

export interface AlphabetListOptions {
  itemTypeName: string;
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    alphabetList: {
      /**
       * Toggle an alphabet list
       */
      toggleAlphabetList: () => ReturnType;
    };
  }
}

export const inputRegex = /^(\d+)\.\s$/;

const alphabetListType = 'alphabetList';

const AlphabetList = Node.create<AlphabetListOptions>({
  name: alphabetListType,

  addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {},
    };
  },

  group: 'block list',

  content() {
    return `${this.options.itemTypeName}+`;
  },

  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: element => {
          return element.hasAttribute('start')
            ? parseInt(element.getAttribute('start') || '', 10)
            : 1;
        },
      },
      type: {
        default: 'a',
      },
      style: {
        default: 'list-style: lower-latin;',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'ol',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { start, ...attributesWithoutStart } = HTMLAttributes;

    return start === 1
      ? [
          'ol',
          mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart),
          0,
        ]
      : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      toggleAlphabetList: () => ({ commands }) => {
        return commands.toggleList(this.name, this.options.itemTypeName);
      },
    };
  },

  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: match => ({ start: +match[1] }),
        joinPredicate: (match, node) =>
          node.childCount + node.attrs.start === +match[1],
      }),
    ];
  },
});

export default { node: AlphabetList, type: alphabetListType };
